module.exports = "https://static.wmbcdn.com/uniweb/images/f9e86cddb93efb39121e1365931b8d26.svg";